export default {"src":"/_next/static/media/no-result.5e135777.svg","height":239,"width":451,"blurWidth":0,"blurHeight":0};